import type { Entity } from '@backstage/catalog-model';

/** The TechDocs reader route for an entity, e.g. `/documentation/default/component/widget`. */
export const readerPath = (entity: Entity): string =>
  `/documentation/${entity.metadata.namespace ?? 'default'}/${entity.kind.toLowerCase()}/${
    entity.metadata.name
  }`;
